import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import config from 'config'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { redirectToBack } from 'srcReact/helpers/history'

import styles from './styles.module.scss'
import BackNavigation from 'srcReact/components/common2/BackNavigation'

export default function TermsOfServices() {
  const { t } = useTranslation()
  const {
    common: { isNative }
  } = useSelector((state) => state)

  return (
    <PageContainer pageTitle={t('terms_of_services.title')} withFooter={false}>
      <div className={styles.termsWrapper}>
        <div className={styles.headerWrapper}>
          <img
            src={`${config.assetUrl + '/images/background-default-mixr.jpeg'}`}
            alt={t('terms_of_services.main_title')}
          />
          <BackNavigation theme='white' className={styles.back} customHandleBack={() => redirectToBack(false)} />
          <h2 className={styles.mainTitle}>{t('terms_of_services.main_title')}</h2>
          <p className={styles.mainDesc}>{t('terms_of_services.main_desc')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_1')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_1_1')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_1_2')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_1_3')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_2')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_2_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_2_2')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_2_3') }}></p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_2_4')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_3')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_3_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_4')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_4_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_4_2')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_4_3')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_5')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_5_1')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_5_2')}</p>
          <ul className={styles.listHead}>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_1')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_2')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_3')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_4')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_5')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_6')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_7')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_8')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_9')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_10')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_5_11')}</li>
          </ul>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_5_3')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_6')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_6_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_6_2')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_6_3')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_7')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_7_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_8')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_6_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_6_2')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_9')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_9_1')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_9_2')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_10')}</h2>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_10_1') }}></p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_10_2')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_11')}</h2>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_11_1') }}></p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_11_2')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_12')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_12_1')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_13')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_13_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_14')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_14_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_14_2')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_14_3')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_15')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_15_1')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_15_2')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_16')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_16_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_16_2')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_17')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_17_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_18')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_2')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_3')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_4')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_5')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_18_6')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_18_7') }}></p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_19')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_1')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_2')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_3')}</p>
          <ul className={styles.listHead}>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_1')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_2')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_3')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_4')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_5')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_6')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_7')}</li>
          </ul>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_19_4') }}></p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_5')}</p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_6')}</p>
          <ul className={styles.listHead}>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_8')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_9')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_10')}</li>
            <li className={styles.list}>{t('terms_of_services.sub_list_19_11')}</li>
          </ul>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_19_7')}</p>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_19_8') }}></p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_20')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_20_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_20_2')}</p>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_20_3') }}></p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_21')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_21_1')}</p>
          <p className={styles.subDesc} dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_21_2') }}></p>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_21_3')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_22')}</h2>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_22_1')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_22_2')}</p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_22_3')}</p>
          <ul className={styles.listHead}>
            <li className={`${styles.list} ${styles.white}`}>{t('terms_of_services.sub_list_22_1')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('terms_of_services.sub_list_22_2')}</li>
          </ul>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_22_4')}</p>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_23')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_23_1')}</p>
        </div>
        <div className={`${styles.contentWrapper} ${styles.green}`}>
          <h2 className={`${styles.subTitle} ${styles.white}`}>{t('terms_of_services.sub_heading_24')}</h2>
          <p
            className={`${styles.subDesc} ${styles.white}`}
            dangerouslySetInnerHTML={{ __html: t('terms_of_services.sub_desc_24_1') }}></p>
          <p className={`${styles.subDesc} ${styles.white}`}>{t('terms_of_services.sub_desc_24_2')}</p>
          <ul className={styles.listHead}>
            <li className={`${styles.list} ${styles.white}`}>{t('terms_of_services.sub_list_24_1')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('terms_of_services.sub_list_24_2')}</li>
            <li className={`${styles.list} ${styles.white}`}>{t('terms_of_services.sub_list_24_3')}</li>
          </ul>
        </div>
        <div className={styles.contentWrapper}>
          <h2 className={styles.subTitle}>{t('terms_of_services.sub_heading_25')}</h2>
          <p className={styles.subDesc}>{t('terms_of_services.sub_desc_25_1')}</p>
        </div>
      </div>
    </PageContainer>
  )
}
